import {Component, Vue} from 'vue-property-decorator'
import {menuBtn} from "@/utils/menu_level2_button";
import {gettHeaderByType, settHeaderByType} from "@/api/common";
import {delNullProperty} from "@/utils";
import {
    getStudentList,
    exportStudent,
    addClasses,
    setStudentByclasserId,
    getClasses,
    setStudentToNewClasserId
} from "@/api/classManage";
import {UserModule} from "@/store/modules/user";
import {formatDate} from "@/utils/timeFilter";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

@Component({
    components: {
        MoreUsersFilter
    }
})
export default class Student extends Vue {
    // ------ 变量 ------
    buttonShow = menuBtn // 方法：按钮权限验证
    tableData = []
    checkTableList = []
    page = 1
    pageSize = 20
    total = 0
    loading = false
    studentTableHead = [] // 表头顺序列表
    draggableListChange = []
    draggableList = []
    tableHeadPopoverShow = false // 调整表头顺序的弹框是否可见
    vdaH = 0 //屏幕高度
    popHeight = 0
    timer = null
    exportButtonDisabled = false
    exportHeaderDialogVisible = false
    filterList = {
        customerName: '',
        customerCode: '',
        customerSource: '',
        code: '',
        souCourseTypeIdStr: '',
        souCourseName: '',
        souCourseSchoolBegin: '',
        isClasses: '',
        classesName: '',
        classesCode: '',
        teacherUserId: '',
        thesisUserId: '',
        helperUserId: '',
        isCredit: '',
        publicationOutput: '',
        learningOutput: '',
        haveIPQ: '',
    }
    typeList = commonData.projectTypeArray
    createdAt: Date[] | null = null // 开课时间
    dialogEnterClassVisible = false
    formData = {
        classRatio: '1',
        name: '',
        code: '',
        teacherUserId: '',
        thesisUserId: '',
        helperUserId: '',
        applyUserId: '',
    }
    projectAllId = null
    alreadyClassId = null
    classesList = []

    classespageSize = 20

    query = ''
    dialogTurnClassVisible = false
    turnOldClassesId = null
    turnAndEnterprojectAllId = null
    alreadyClassName = ''
    name = ''
    formRules = {
        classRatio: [{required: true, message: '请选择班级', trigger: ['blur', 'change']}],
        name: [{required: true, message: '请填写班级名称', trigger: ['blur', 'change']}],
    }
    userList1 = []
    souCourseTypeIdList = []
    enterClassLoading = false
    turnClassLoading = false

    created() {
        this.getStudentHeader()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260;
        this.popHeight = this.vdaH
    }

    // 获取表头
    async getStudentHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(21)
        this.draggableList = data.headerUserList
        this.studentTableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }

    async getTableData() {
        this.loading = true
        this.checkTableList = []
        this.filterList.souCourseSchoolBegin = this.changeTime(this.createdAt as Date[])
        this.filterList.souCourseTypeIdStr = this.souCourseTypeIdList.join(',')
        const obj = {
            ...this.filterList,
            page: this.page,
            limit: this.pageSize,
        }
        await getStudentList(delNullProperty(obj)).then((data: any)=>{
            this.tableData = data.studentList
            this.total = data.allNum

            this.$nextTick(() => {
                if (this.$refs.multipleTable) {
                    (this.$refs.multipleTable as HTMLFormElement).doLayout();
                    (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
                }
            });

            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(val: number) {
        this.pageSize = val
        this.getTableData()
    }

    // 取消调整表头
    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        this.tableHeadPopoverShow = false
    }

    // 改变表头顺序
    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 21})
            this.$message.success('修改表头顺序成功')
            this.getStudentHeader()
            this.tableHeadPopoverShow = false
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    getStudentExportData(keys: string = '') {
        this.exportButtonDisabled = true
        this.filterList.souCourseSchoolBegin = this.changeTime(this.createdAt as Date[])
        this.filterList.souCourseTypeIdStr = this.souCourseTypeIdList.join(',')
        const obj = {
            ...this.filterList,
            keys,
        }

        exportStudent(delNullProperty(obj)).then(() => {
            this.exportButtonDisabled = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => {
            this.exportButtonDisabled = false
        })

    }


    // 表格选中情况发生改变时
    handleSelectionChange(arr: any) {
        this.checkTableList = arr
    }


    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy/MM/dd', new Date(item)) + '-'
        })
        time = time.slice(0, time.length - 1)
        return time
    }

    // 查看
    handleClassesStudent(id) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/classesStudentInfo?id=' + id + '&isShow=0', "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    /*
    * 入班*/
    handleEnterClass(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/classesStudentInfo?id=' + row.id + '&isShow=1&isTurnClass=0', "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    /*
    * 调班*/
    handleTurnClass(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/classesStudentInfo?id=' + row.id + '&isShow=1&isTurnClass=1', "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    //    批量入班
    batchEnterClass() {
        // 校验是否同一个项目id
        const notEqualFlag = this.checkTableList.some(
            (item) => this.checkTableList.filter((ele) => ele.projectAllId !== item.projectAllId).length >= 1  // 返回true 有不同 返回false 全部相等
        );
        const notEqualFlag1 = this.checkTableList.some(
            () => this.checkTableList.filter((ele) => ele.isClasses !== '待入班').length >= 1  // 返回true 有不同 返回false 全部相等
        );
        if (notEqualFlag1) {
            this.$message.error('请选择入班状态为【待入班】的数据进行批量操作')
            return
        }
        if (notEqualFlag) {
            this.$message.error('项目不同，请选择报名项目相同的学生进行批量操作')
            return
        }
        if (!notEqualFlag && !notEqualFlag1) {
            this.turnAndEnterprojectAllId = this.checkTableList[0].projectAllId
            this.dialogEnterClassVisible = true
            this.getClassesList()
        }
    }

    // 批量调班
    batchTurnClass() {
        const notEqualFlag = this.checkTableList.some(
            (item) => this.checkTableList.filter((ele) => ele.projectAllId !== item.projectAllId).length >= 1  // 返回true 有不同 返回false 全部相等
        );
        const notEqualFlag1 = this.checkTableList.some(
            () => this.checkTableList.filter((ele) => ele.isClasses !== '已入班').length >= 1  // 返回true 有不同 返回false 全部相等
        );
        if (notEqualFlag1) {
            this.$message.error('请选择入班状态为【已入班】的数据进行批量操作')
            return
        }
        if (notEqualFlag) {
            this.$message.error('项目不同，请选择报名项目相同的学生进行批量操作')
            return
        }
        if (!notEqualFlag && !notEqualFlag1) {
            this.turnOldClassesId = this.checkTableList[0].classesId
            this.turnAndEnterprojectAllId = this.checkTableList[0].projectAllId
            this.dialogTurnClassVisible = true
            this.getClassesList()
        }
    }

    doCancelEnterDialog() {
        this.dialogEnterClassVisible = false
        this.formData.classRatio = '1'
        this.formData.name = ''
        this.formData.code = ''
        this.formData.teacherUserId = ''
        this.formData.thesisUserId = ''
        this.formData.helperUserId = ''
        this.formData.applyUserId = ''
        this.alreadyClassName = ''
    }

    async doConfirmEnterDialog() {
        const idList = this.checkTableList.map(item => item.id)
        this.enterClassLoading = true
        if (this.formData.classRatio == '1') {// 新建
            let flag = true;
            (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
                if (!valid) {
                    flag = false
                    return
                }
            })

            const obj = {
                name: this.formData.name,
                code: this.formData.code.trim(),
                teacherUserId: this.formData.teacherUserId,
                thesisUserId: this.formData.thesisUserId,
                helperUserId: this.formData.helperUserId,
                applyUserId: this.formData.applyUserId,
                projectAllId: this.turnAndEnterprojectAllId
            }
            if (flag) {

                const data: any = await addClasses(delNullProperty(obj)).catch(err => {
                    this.enterClassLoading = false
                })
                await setStudentByclasserId(data.id, {idList: idList}).then(() => {
                    this.enterClassLoading = false
                    this.$message.success('批量入班成功')

                    this.dialogEnterClassVisible = false
                    this.formData.classRatio = '1'
                    this.formData.name = ''
                    this.formData.code = ''
                    this.formData.teacherUserId = ''
                    this.formData.thesisUserId = ''
                    this.formData.helperUserId = ''
                    this.formData.applyUserId = ''
                    this.classesList = []
                    this.getTableData()
                }).catch(err => {
                    this.enterClassLoading = false
                })
            }
        } else if (this.formData.classRatio == '2') { // 选择已有的
            if (!this.alreadyClassId) {
                this.$message.error('请选择已有班级')
                return;
            }
            await setStudentByclasserId(this.alreadyClassId, {idList: idList}).then(() => {
                this.enterClassLoading = false
                this.$message.success('批量入班成功')
                this.alreadyClassName = ''
                this.dialogEnterClassVisible = false
                this.classesList = []
                this.getTableData()
            }).catch(err => {
                this.enterClassLoading = false
            })
        }
    }

    handleClose() {
        this.dialogEnterClassVisible = false
        this.formData.classRatio = '1'
        this.formData.name = ''
        this.formData.code = ''
        this.formData.teacherUserId = ''
        this.formData.thesisUserId = ''
        this.formData.helperUserId = ''
        this.formData.applyUserId = ''
        this.alreadyClassName = ''
    }


    handleTurnClose() {
        this.dialogTurnClassVisible = false
        this.formData.classRatio = '1'
        this.formData.name = ''
        this.formData.code = ''
        this.formData.teacherUserId = ''
        this.formData.thesisUserId = ''
        this.formData.helperUserId = ''
        this.formData.applyUserId = ''
        this.alreadyClassName = ''
    }

    doCancelTurnDialog() {
        this.dialogTurnClassVisible = false
        this.formData.classRatio = '1'
        this.formData.name = ''
        this.formData.code = ''
        this.formData.teacherUserId = ''
        this.formData.thesisUserId = ''
        this.formData.helperUserId = ''
        this.formData.applyUserId = ''
        this.alreadyClassName = ''
    }

    async doConfirmTurnDialog() {
        const idList = this.checkTableList.map(item => item.id)
        this.turnClassLoading = true
        if (this.formData.classRatio == '1') {// 新建
            let flag = true;
            (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
                if (!valid) {
                    flag = false
                    return
                }
            })
            const obj = {
                name: this.formData.name,
                code: this.formData.code.trim(),
                teacherUserId: this.formData.teacherUserId,
                thesisUserId: this.formData.thesisUserId,
                helperUserId: this.formData.helperUserId,
                applyUserId: this.formData.applyUserId,
                projectAllId: this.turnAndEnterprojectAllId
            }
            if (flag) {
                const data: any = await addClasses(delNullProperty(obj)).catch(err => {
                    this.turnClassLoading = false
                })
                await setStudentToNewClasserId(this.turnOldClassesId, data.id, {idList: idList}).then(() => {
                    this.turnClassLoading = false
                    this.$message.success('批量调班成功')
                    this.formData.classRatio = '1'
                    this.formData.name = ''
                    this.formData.code = ''
                    this.formData.teacherUserId = ''
                    this.formData.thesisUserId = ''
                    this.formData.helperUserId = ''
                    this.formData.applyUserId = ''
                    this.dialogTurnClassVisible = false
                    this.classesList = []
                    this.getTableData()
                }).catch(err => {
                    this.turnClassLoading = false
                })
            }
        } else if (this.formData.classRatio == '2') { // 选择已有的
            if (!this.alreadyClassId) {
                this.$message.error('请选择已有班级')
                return;
            }
            await setStudentToNewClasserId(this.turnOldClassesId, this.alreadyClassId, {idList: idList}).then(() => {
                this.turnClassLoading = false
                this.$message.success('批量调班成功')
                this.alreadyClassName = ''
                this.dialogTurnClassVisible = false
                this.classesList = []
                this.getTableData()
            }).catch(err => {
                this.turnClassLoading = false
            })

        }
    }

    async getClassesList() {
        const data: any = await getClasses(delNullProperty({
            limit: this.classespageSize,
            name: this.name,
            projectAllId: this.turnAndEnterprojectAllId
        }))
        this.classesList = [...this.classesList, ...data.classesList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.classesList.length; i++) {
            if (!obj[this.classesList[i].id]) {
                result.push(this.classesList[i]);
                obj[this.classesList[i].id] = true;
            }
        }
        this.classesList = result
        if (this.classesList.length == 0 && this.formData.classRatio == '2') {
            this.$message.error('该项目下暂无班级，请去新建')
        }
    }

    loadmore() {
        this.classespageSize += 20;
        this.getClassesList();
    }

    async getFoucsClassList() {
        if (this.classesList.length == 0 && !this.alreadyClassName) {
            this.name = ''
            this.classespageSize = 20
            const result: any = await getClasses(delNullProperty(
                {
                    limit: this.classespageSize,
                    name: this.name,
                    projectAllId: this.turnAndEnterprojectAllId
                }
            ))
            this.classesList = result.classesList
            if (this.classesList.length == 0) {
                this.$message.error('该项目下暂无班级，请去新建')
            }
        }
        if (this.alreadyClassName) {
            this.classesList = []
            this.classespageSize = 20
            const result: any = await getClasses({
                limit: this.classespageSize,
                name: this.alreadyClassName,
                projectAllId: this.turnAndEnterprojectAllId
            })
            this.classesList = result.classesList
            if (this.classesList.length == 0) {
                this.$message.error('该项目下暂无班级，请去新建')
            }
        }
    }

    clearClassList() {
        if (!this.alreadyClassName) {
            this.name = ''
            this.classespageSize = 20
            this.getClassesList()
        }
    }

    async remoteMethod(query: any) {
        this.name = query
        this.classespageSize = 20
        if (query !== '') {
            const result: any = await getClasses({
                limit: this.classespageSize,
                name: this.name,
                projectAllId: this.turnAndEnterprojectAllId
            })
            this.classesList = result.classesList
            if (this.classesList.length == 0) {
                this.$message.error('该项目下暂无班级，请去新建')
            }
        } else {
            this.classesList = []
            this.getClassesList();
        }
    }

    changeAlreadyClass(val) {
        this.alreadyClassId = val
    }

    changeTeacherUsers(e){
        this.filterList.teacherUserId = e.id
        this.page = 1
        this.getTableData()
    }

    changeThesisUserIds(e){
        this.filterList.thesisUserId = e.id
        this.page = 1
        this.getTableData()
    }

    changeHelperUserIds(e){
        this.filterList.helperUserId = e.id
        this.page = 1
        this.getTableData()
    }

    changeTeacherUsers1(e){
        this.formData.teacherUserId = e.id
    }

    changeThesisUsers(e){
        this.formData.thesisUserId = e.id
    }

    changeHelperUsers(e){
        this.formData.helperUserId = e.id
    }
    changeApplyUserId(e){
        this.formData.applyUserId = e.id
    }

    getStudentStaticData(){
        window.open(window.location.origin + this.$route.matched[0].path + '/ClassStudentStaticData')
    }
}
